import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=0b767f96&scoped=true&"
import script from "./ResourceCard.vue?vue&type=script&lang=js&"
export * from "./ResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ResourceCard.vue?vue&type=style&index=1&id=0b767f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b767f96",
  null
  
)

export default component.exports